import { render } from "./ComparativeTVPHighlights.vue?vue&type=template&id=89aae38c"
import script from "./ComparativeTVPHighlights.vue?vue&type=script&lang=js"
export * from "./ComparativeTVPHighlights.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__